import { AdminNavbar } from 'components/AdminNavbar'
import { Footer } from 'components/Footer'
import { Outlet } from 'react-router'
import axios from 'axios'
import { useAuth } from 'hooks/useAuth'
import { useAuthContext } from 'context/authContext'
import { useEffect, useState } from 'react'
import { exportElementToPdf } from 'utils/exportPdf'

export const AdminPage = () => {
    const { me } = useAuth()
    const { logout } = useAuthContext()
    const [isPrinting, setIsPrinting] = useState(false)

    // Expired / invalid JWT: go back to the login page
    useEffect(() => {
        if (axios.isAxiosError(me.error) && me.error.response?.status === 401) {
            logout()
        }
    }, [me.error, logout])

    const printDocument = async () => {
        const input = document.getElementById('divToPrint')
        if (input == null || isPrinting) {
            return
        }
        setIsPrinting(true)
        try {
            await exportElementToPdf(input, 'download.pdf')
        } finally {
            setIsPrinting(false)
        }
    }

    return (
        <div id='divToPrint' className='flex min-h-screen flex-col bg-canvas text-ink'>
            <AdminNavbar
                onPressPrint={printDocument}
                isPrinting={isPrinting}
                logoUrl={me.data?.school_info?.logo?.url ?? ''}
                schoolName={me.data?.school_info?.name_zh} />
            <div className='flex-1'>
                <Outlet />
            </div>
            <Footer />
        </div>
    )
}
